<div class="d-flex flex-column justify-content-between h-100" id="scroll-to-top-ref">
  <section class="signup-content">

    <header class="animated fadeInDown login-header">
      <button class="btn btn-sm btn-white btn-back" type="button" (click)="goBack()">
        <span class="material-symbols-outlined">
          chevron_left
        </span> GO BACK
      </button>
    </header>

    <div class="signup" [class.w-80]="currentStepIndex() === 3">

      <img class="signup__logo" src="/assets/images/logo.webp" alt="Carlton Farms logo" [routerLink]="['/shop']" />

      @if (isLoadingContent() || accountService.isLoading() || isWaitingResponse()) {
      <mat-progress-bar mode="indeterminate" value="accent"></mat-progress-bar>
      }

      <header class="text-center">
        <h1 class="h4-bold text-secondary-800">
          CREATE YOUR ACCOUNT
        </h1>
      </header>

      <!-- @if (isLoadedMarketingValidations() || isTryingToApplyCoupon()) { -->
      @if (signupPromotionInfo()?.code && signupPromotionInfo()?.name) {
      <div class="alert alert-success border-0 z-1020 fade show animated fadeInUp rounded-3"
        [class.animated]="!isTryingToApplyCoupon()" role="alert">
        <div class="d-flex justify-content-center align-items-center gap-3">

          @if (signupPromotionInfo()?.code && signupPromotionInfo()?.name) {
          <section
            class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row  align-items-center gap-2 gap-sm-2 gap-md-3 gap-lg-3">
            <section class="d-flex align-items-center gap-2 justify-content-center">
              <i class="fas fa-tag"></i>
              <strong>Discount successfully applied!</strong>
            </section>
            <section class="d-flex align-items-center gap-2 justify-content-center">
              <i class="fw-semibold">({{signupPromotionInfo().code}})</i>
              {{signupPromotionInfo().name}}
            </section>
            <!-- <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
              (click)="clearSignupPromotionInfo()" ngbTooltip="Change Coupon Code">
              <i class="fas fa-sync"></i>
              <a href="javascript:void(0)" class="link-color">
                Change Coupon
              </a>
            </section> -->
          </section>
          } @else {
          <section
            class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row  align-items-center gap-2 gap-sm-2 gap-md-3 gap-lg-3">
            <section class="d-flex align-items-center gap-2 justify-content-center">
              <i class="fas fa-tag"></i>
              <strong class="text-nowrap">Have a coupon? Apply it here:</strong>
            </section>
            <section class="d-flex align-items-center gap-3">
              <input type="text" class="form-control form-control-sm" placeholder="Coupon Code" #signupCouponCode
                (keyup.enter)="applySignupCoupon(signupCouponCode.value)">

              <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
                (click)="applySignupCoupon(signupCouponCode.value)">
                <i class="fas fa-check"></i>
                <a href="javascript:void(0)" class="link-color">
                  Apply
                </a>
              </section>

              @if (signupPromotionInfoFromLS()?.code && signupPromotionInfoFromLS()?.name) {
              or

              <section class="d-flex justify-content-center align-items-center gap-1 link-color h7-bold"
                (click)="restoreSignupInfo()">
                <i class="fas fa-times"></i>
                <a href="javascript:void(0)" class="link-color">
                  Cancel
                </a>
              </section>

              }
            </section>
          </section>
          }

        </div>
      </div>}

      <mat-stepper linear [disableRipple]="true" labelPosition="bottom"
        (selectedIndexChange)="currentStepIndex.set($event)" #stepper>

        <!-- Delivery information -->
        <mat-step #firstStep [completed]="firstStep.completed" [editable]="false">

          <ng-template matStepLabel>
            Delivery Information
          </ng-template>

          <app-check-address-signup [firstStep]="firstStep"
            (deliveryAddressChanged)="deliveryAddressInformation = $event"
            (selectedDayChanged)="deliverySelectedDay = $event"
            (selectedTimeWindowChanged)="deliverySelectedTimeWindow = $event"
            (deliveryOptionChanged)="deliveryOptionSelected = $event" (onNextStep)="continue()">
          </app-check-address-signup>

          <ng-container *ngTemplateOutlet="signInNow"></ng-container>

        </mat-step>

        <!-- Personal information -->
        <mat-step [completed]="formValidityPersonalInformation && firstStep.completed" [editable]="false">

          <ng-template matStepLabel>
            Personal Information
          </ng-template>

          <app-personal-information-signup [stepper]="matStepper()" [firstStep]="firstStep"
            #personalInformationComponent [creatingAccount]="shouldDisableCreateClientButton()"
            (formValidityChanged)="formValidityPersonalInformation = $event"
            (personalInformationChanged)="personalInformationData = $event" (onNextStep)="createNewClient()">
          </app-personal-information-signup>

        </mat-step>

        <!-- Payment method information -->
        <mat-step [completed]="false" [editable]="false" #paymentMethodStep>

          <ng-template matStepLabel>
            Payment Information
          </ng-template>

          <app-payment-method-signup (formValidityChanged)="formValidityPaymentMethod = $event"
            (onNextStep)="continue()" [in_selectedMembership]="deliveryOptionSelected">
          </app-payment-method-signup>

        </mat-step>

        <!-- Subscription products -->
        <mat-step [editable]="false" [completed]="false" #subscriptionStep>

          <ng-template matStepLabel>
            Subscription Products
          </ng-template>

          <app-subscriptions-signup [products]="signupProducts()"></app-subscriptions-signup>

        </mat-step>

      </mat-stepper>

    </div>

  </section>

  <app-faqs class="animated fadeInUp" [step]="matStepper().selectedIndex"></app-faqs>
  <app-footer class="animated fadeInUp"></app-footer>

  <ng-template #signInNow>
    <footer class="d-flex gap-2 flex-wrap mt-3 justify-content-center">
      <span class="h6-regular">Already have an account?</span>
      <span class="h6-regular cursor-pointer link-color" [routerLink]="'/login'">Sign in now</span>
    </footer>
  </ng-template>
</div>